export default "__VITE_ASSET__95de1d6b__"